export const GTM_EVENT_NAME_SME_LEASE_CALCULATOR_CAR = 'smeLeaseCalculatorCar';
export const GTM_EVENT_NAME_SME_REQUEST_CALL = 'smeRequestCall';
export const GTM_EVENT_NAME_ONE_TAG = 'smeOneTagEvent';

export const GTM_EVENT_STAGE_CHOOSE_YOUR_VEHICLE = 'choose your vehicle';
export const GTM_EVENT_STAGE_UPDATE_SEARCH = 'update search';
export const GTM_EVENT_STAGE_NO_RESULTS_FOUND = 'no results found';
export const GTM_EVENT_STAGE_ADD_TO_SHORTLIST = 'add_to_shortlist';
export const GTM_EVENT_STAGE_VIEW_SHORTLIST = 'view_shortlist';
export const GTM_EVENT_STAGE_VIEW_ENQUIRY = 'view_enquiry';
export const GTM_EVENT_STAGE_VIEW_PAYMENT_BREAKDOWN = 'view_payment_breakdown';
export const GTM_EVENT_STAGE_SUBMIT_ENQUIRY_CREATE_ACCOUNT = 'submit_enquiry_create_account';
export const GTM_EVENT_STAGE_SUBMIT_ENQUIRY_CALL_ME = 'submit_enquiry_call_me';
export const GTM_EVENT_STAGE_SUBMIT_ENQUIRY_CALL_ME_2 = 'submit_enquiry_call_me_2';
export const SEARCH_FILTER_PARAMETERS = [
  'countryCode',
  'pair',
  'brokerId',
  'vehicleMake',
  'vehicleModel',
  'vehicleMinRRP',
  'vehicleMaxRRP',
  'vehicleFueltype',
  'vehicleSeats',
  'vehicleCategory',
  'vehicleNatureGroup',
  'vehicleTrim',
  'vehicleBodystyle',
  'vehicleDriveTrain',
  'vehicleTransmission',
  'cabType',
  'minBudget',
  'maxBudget',
  'budgetType',
  'sortOrder',
  'sortBy',
  'pageSize',
  'currentPage',
  'referenceId',
  'catalogVehicleId',
  'minDuration',
  'maxDuration',
  'vehicleBodytype',
  'isCountRow'
];

/** Mobile refine stack category ids (VehicleResult filter drawer hub + drill-down). */
export const REFINE_MOBILE_STACK_FILTER = Object.freeze({
  MAKE: 'make',
  MODEL: 'model',
  BUDGET: 'budget',
  FUEL: 'fuel',
  POWER_TRAIN: 'powerTrain',
  STYLE: 'style'
});

export const GTM_EVENT_VALUES_LEASE_CALCULATOR_CAR = {
  make: undefined,
  fuel: undefined,
  type: undefined,
  model: undefined,
  variant: undefined,
  pay_cycle: undefined,
  purchase_price: undefined
};

export const GTM_EVENT_VALUES_ONE_TAG = {
  make: undefined,
  fuel: undefined,
  type: undefined,
  variant: undefined,
  purchase_price: undefined,
  vehicleCategory: undefined,
  vehicleDrivetrain: undefined,
  vehicleModel: undefined
};
export const MAKES_SEPARATOR = '_';
export const MAKE_MODELS_SEPARATOR = '.';
export const MULTI_MODELS_SEPARATOR = ',';

export const OLD_MAKES_SEPARATOR = '|';
export const OLD_MAKE_MODELS_SEPARATOR = ':';

export const BUTTON_STYLE_ROUNDED = 'rounded';
export const BUTTON_STYLE_SQUARE = 'square';

export const FONT_FAMILY_MMC = 'mmc';
export const FONT_FAMILY_NUNITO = 'nunito';
export const DEFAULT_LEASE_TERM = 60;
export const REPAYMENT_WEEKLY = 'weekly';
export const REPAYMENT_MONTHLY = 'monthly';
export const REPAYMENT_OPTIONS = [REPAYMENT_WEEKLY, REPAYMENT_MONTHLY];

export const RATEBOOK_SORT_WEEK_LEASE_PRICE = 'week_leaseprice';
export const RATEBOOK_SORT_MONTH_LEASE_PRICE = 'month_leaseprice';

export const LEASE_TERM_OPTIONS = [
  { label: '3 years', value: 36 },
  { label: '4 years', value: 48 },
  { label: '5 years', value: 60 }
];

export const CALCULATOR_ENQUIRE_TYPE = {
  CALL_ME: 'call',
  CREATE_ACCOUNT: 'register'
};

export const OPPORTUNITY_STAGES_BLOCKING_SEND_APPLICATION = ['Deal Mobilising', 'Submitted to Credit', 'Doc Production'];

export const ENQUIRE_SHORTLIST_PAYLOAD_OMIT_KEYS = [
  'marketingSubject',
  'marketingBodyText',
  'fuelConsumption',
  'coEmission',
  'maxLoad',
  'trailerLoadBraked',
  'serviceSchedule',
  'engineKw',
  'engineCc',
  'vehicleNrofcylinders',
  'tankCapacity',
  'vehicleWarranty',
  'vehicleNrofpassengers',
  'vehicleFinance',
  'vehicleFinanceWeekly',
  'vehicleRunningCost',
  'vehicleRunningCostWeekly',
  'ancapRating',
  'quoteRefId',
  'creationDate',
  'deletedAt'
];
